var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12",attrs:{"align":"center"}},[_c('img',{staticStyle:{"position":"relative","top":"50%"},attrs:{"width":"20%","src":_vm.ogeoLogo,"alt":"Ogeo Logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }